import React, { useState } from "react";

import { Layout, Notification, UserMenu, MenuItemLink } from "react-admin";

import MoreVertIcon from "@material-ui/icons/MoreVert";

import { useUser } from "../../authenticatorApp/UserContext";
import DefaultError from "../../components/DefaultError";
import {
  AppInfoIcon,
  BugIcon,
  BusinessIcon,
  ContrastIcon,
  LogoutIcon,
  ProfileIcon,
  ThemeToggleIcon,
} from "../../components/common/iconography";
import { AppInfoDialog } from "../../components/common/AppInfoDialog";
import { MenuItemClickable } from "../../components/MenuItemClickable";

import { useThemeState } from "../../ThemeStateProvider";
import { COMPANY_PATH } from "../carrierPaths";
import { CarrierMenu } from "./CarrierMenu";
import { CarrierAppBar } from "./CarrierAppBar";
import { MissingCarrierIdBanner } from "./MissingCarrierIdBanner";

const CarrierUserMenu = ({ toggleAppInfoOpen, ...props }) => {
  const { appUser } = useUser();
  const { toggleContrast, togglePalette } = useThemeState();
  const profilePath = `/carrierUsers/${appUser?.id}`;

  const handleBugReport = () => {
    window.open("https://transloads.co/submit-a-ticket/", "_blank");
  };

  return (
    <UserMenu label="USER" icon={<MoreVertIcon />}>
      <MenuItemLink
        to={profilePath}
        primaryText="Profile"
        leftIcon={<ProfileIcon />}
      />
      {/* The person above, the company here. The two are separate records: a
          dispatcher's own name and phone are theirs, while the business name and
          the company's ID numbers belong to the carrier. */}
      <MenuItemLink
        to={COMPANY_PATH}
        primaryText="Company Profile"
        leftIcon={<BusinessIcon />}
      />
      <MenuItemClickable
        primaryText="Theme"
        leftIcon={<ThemeToggleIcon />}
        clickHandler={togglePalette}
      />
      <MenuItemClickable
        primaryText="Contrast"
        leftIcon={<ContrastIcon />}
        clickHandler={toggleContrast}
      />
      <MenuItemClickable
        primaryText="App Info"
        leftIcon={<AppInfoIcon />}
        clickHandler={toggleAppInfoOpen}
      />
      <MenuItemClickable
        primaryText="Log a Ticket"
        leftIcon={<BugIcon />}
        clickHandler={handleBugReport}
      />
      <MenuItemLink
        to="/logout"
        primaryText="Logout"
        leftIcon={<LogoutIcon />}
      />
    </UserMenu>
  );
};

export const CarrierLayout = (props) => {
  const [appInfoOpen, setAppInfoOpen] = useState(false);
  const toggleAppInfoOpen = (_, reason) => {
    if (reason !== "backdropClick") setAppInfoOpen(!appInfoOpen);
  };
  const userMenu = <CarrierUserMenu toggleAppInfoOpen={toggleAppInfoOpen} />;

  return (
    <>
      <Layout
        {...props}
        appBar={(props) => CarrierAppBar(props, userMenu)}
        menu={CarrierMenu}
        notification={Notification}
        error={DefaultError}
      >
        {/* Above the routed page on every screen: the notice about a company
            profile with no carrier ID has no page of its own to live on. */}
        <MissingCarrierIdBanner />
        {props.children}
      </Layout>
      <AppInfoDialog isOpen={appInfoOpen} onClose={toggleAppInfoOpen} />
    </>
  );
};
